import React, { createContext, useState, useContext } from 'react';

const SelectedRowsContext = createContext();

export const SelectedRowsProvider = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  return (
    <SelectedRowsContext.Provider value={{ selectedRows, setSelectedRows, selectedFiles, setSelectedFiles }}>
      {children}
    </SelectedRowsContext.Provider>
  );
};

export const useSelectedRows = () => useContext(SelectedRowsContext);
